export default __webpack_public_path__ + "static/media/line-seq-swap-arrow-up-black.dd60de58.svg";